import React, { useContext, useEffect, useState } from "react";
import { Radio, Snackbar } from "@material-ui/core";
import { useHistory } from "react-router";
import { MdOutlineEdit } from "react-icons/md";
import { AiOutlineClose } from "react-icons/ai";
import { Image, Shimmer } from "react-shimmer";
import { Alert } from "@material-ui/lab";

import styles from "./checkout.module.css";
import { MainContext } from "../../utils/context";
import { api_call_token } from "../../utils/Network";
import { appendImageUrl, isMobiledevice } from "../../utils/helperFunctions";
import Payment from "../../components/Payment";
import AddressPopup from "../../components/AddressPopup";

function Checkout() {
  const { cartData, setCartData, userData, setCurrentPath } = useContext(
    MainContext
  );
  const [addressPopup, setAddressPopup] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [addressSelected, setAddressSelected] = useState({});
  const [orderData, setOrderData] = useState({});
  const [timeselect, setTimeSelect] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);
  const [msg, setMsg] = useState("");
  const history = useHistory();

  useEffect(() => setCurrentPath(window.location.href.split("/")[4]), []);
  useEffect(() => {
    window.scrollTo(0, 0);
    getAddresses();
    if (cartData.length) {
      let total = 0;
      let time = 0;
      cartData.forEach((c) => {
        total = c.service_total
          ? total + c.service_total
          : total + c.service_price;
        time = c.booking_time_slot;
      });
      setTimeSelect(time);
      setCartTotal(total);
    }
  }, [cartData, userData]);

  const getAddresses = () => {
    if (userData?.id)
      api_call_token
        .get("auth/address/view_address/")
        .then((res) => {
          setAddressSelected(res.data.data[0]);
          setAddresses(res.data.data);
        })
        .catch((e) => console.log(e));
  };

  const placeOrderHandler = () => {
    if (addressSelected.address_id) {
      let serviceOrders = [];
      cartData.map((cartItem) => {
        if (cartItem.sub_service?.length)
          cartItem.sub_service.map((addon) => serviceOrders.push(addon));
        serviceOrders.push(cartItem);
      });
      api_call_token
        .post("auth/order/place_order/", {
          order_detail: {
            address_id: addressSelected.address_id,
            total_cost: cartTotal,
            original_cost: cartTotal,
            payment_method: "razor pay",
            user_id: userData?.id,
          },
          service_order: serviceOrders,
        })
        .then((re) => setOrderData(re.data.data))
        .catch((e) => console.log(e));
    } else setMsg("Please select address first");
  };

  const confirmPurchaseHandler = (orderId, paymentId, signature) => {
    setMsg("Order Placed Successfully");
    api_call_token
      .post("auth/order/handle_payment_request/", {
        order_id: orderData.user_detail.order_id,
        razorpay_order_id: orderId,
        razorpay_payment_id: paymentId,
        razorpay_signature: signature,
      })
      .then((re) => {
        setCartData([]);
        history.push("/orders");
      })
      .catch((e) => console.log(e));
  };

  console.log(cartData, "timeselect")
  return (
    <>
      {addressPopup && (
        <AddressPopup
          show={addressPopup}
          onClose={() => setAddressPopup(false)}
          onSuccess={(ms, addressList) => {
            getAddresses();
            setMsg(ms);
            setAddressPopup(false);
          }}
          updateAddress={addressSelected}
        />
      )}
      {orderData.id && (
        <Payment
          confirmPurchase={confirmPurchaseHandler}
          amountDue={orderData.amount_due}
          orderId={orderData.id}
          user={userData}
        />
      )}
      <div className={`${styles.checkHead} ${styles.cart_main}`}>
        <div>
          <h2 className={styles.checkout_content}>Checkout</h2>
        </div>
        <div className={styles.checkSum}>
          <div style={{ marginRight: "20px" }}>
            <div className={styles.total}>Total</div>
            <div className={styles.totalAmt}>&#8377;{cartTotal.toFixed(2)}</div>
          </div>
          <button onClick={placeOrderHandler} className={styles.btn_checkout}>
            Place Order
          </button>
        </div>
      </div>
      <div className={styles.checkout_contents}>
        <div className={`${styles.sub_check_main} ${styles.cart_main}`}>
          <div className={styles.cart_div_one}>
            <div className={styles.addr_cont_container}>
              <h1 className={styles.ad_titles}>Delivery Address</h1>
              <div style={{ textAlign: "center" }}>
                <button
                  onClick={() => (
                    setAddressSelected({}),
                    setTimeout(() => setAddressPopup(true), 500)
                  )}
                  className={styles.add_address}
                >
                  Add New Address
                </button>
              </div>
              <div className={styles.addresses}>
                {addresses.map((adrs) => (
                  <div key={adrs.address_id} className={styles.cont_ad_detail}>
                    <div>
                      <Radio
                        size="small"
                        value={adrs.address_id}
                        onChange={(e, v) => setAddressSelected(adrs)}
                        checked={adrs.address_id === addressSelected.address_id}
                        color="primary"
                      />
                      <h4 className={styles.adc_head}>
                        {userData.complete_name
                          ? userData.complete_name
                          : "Address"}
                      </h4>
                    </div>
                    <div>
                      <p className={styles.adc_para}>
                        {adrs.address1} {adrs.address2} {adrs.state}
                        <br />
                        {adrs.city + " - " + adrs.pincode}
                      </p>
                    </div>
                    <div className={styles.address_btns}>
                      <div
                        onClick={() => (
                          setAddressSelected(adrs),
                          setTimeout(() => setAddressPopup(true), 500)
                        )}
                        className={styles.edits}
                      >
                        <MdOutlineEdit
                          style={{ fontSize: 12, marginRight: 4 }}
                        />
                        Edit
                      </div>
                      <div
                        onClick={() => (
                          setAddressSelected({ ...adrs, delete: true }),
                          setTimeout(() => setAddressPopup(true), 500)
                        )}
                        className={styles.edits}
                      >
                        <AiOutlineClose
                          style={{ fontSize: 12, marginRight: 4 }}
                        />
                        Delete
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.cart_div_two}>
            {cartData.map((cartItem) => (
              <div key={cartItem.service_id} className={styles.checkout_datas}>
                <div className={(styles.cart_main, styles.check_container)}>
                  <div className={styles.Check_content_wrapper}>
                    <Image
                      src={appendImageUrl(
                        cartItem.service_image
                          ? cartItem.service_image
                          : "/files/files/Group_472x_Wj1mM5u.png"
                      )}
                      NativeImgProps={{ className: styles.serviceImg }}
                      fallback={
                        <Shimmer
                          height={isMobiledevice() ? 50 : 70}
                          width={isMobiledevice() ? 50 : 70}
                          className={styles.serviceImg}
                        />
                      }
                    />
                    <div>
                      <div style={{ display: "flex" }}>
                        <h3 className={styles.ccw_head}>
                          {cartItem.sq_feet
                            ? cartItem.service_name +
                              ` (${cartItem.sq_feet} sq.ft)`
                            : cartItem.service_name}
                        </h3>
                      </div>
                      {/* <p className={styles.ccw_para}>
                        Lorem ipsum dolar sit amet, consecteturer adipiscing
                        elit, sed diam
                      </p> */}
                      <div className={styles.dateTime}>
                        <div className={styles.ch_date}>
                          {cartItem?.order_booking_date}
                        </div>
                        <div className={styles.ch_date}>
                          {cartItem?.book?.from}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "40%" }}>
                    <div style={{ marginTop: "40px" }}>
                      <div className={styles.roomselect}>
                        {cartItem.variant_type +
                          " - " +
                          cartItem.sub_variant_type}
                      </div>
                    </div>
                    <div className={styles.amount_info}>
                      <div className={styles.amounts}>
                        &#8377;
                        {cartItem.sq_feet
                          ? (cartItem.service_price * cartItem.sq_feet).toFixed(
                              2
                            )
                          : cartItem.service_price}
                      </div>
                    </div>
                  </div>
                </div>
                {cartItem.sub_service?.length > 0 && (
                  <div className={`${styles.cart_main} ${styles.adons_data}`}>
                    <h4>Add Ons</h4>
                    {cartItem.sub_service?.map((addon) => (
                      <div
                        key={addon.service_id}
                        className={styles.adon_container}
                      >
                        <div className={styles.adon_main_wrapper}>
                          <Image
                            src={appendImageUrl(
                              addon.service_image
                                ? addon.service_image
                                : "/files/files/Group_1112x_uioXQAd.png"
                            )}
                            NativeImgProps={{ className: styles.adonImg }}
                            fallback={
                              <Shimmer
                                height={isMobiledevice() ? 40 : 55}
                                width={isMobiledevice() ? 40 : 55}
                                className={styles.adonImg}
                              />
                            }
                          />
                          <h4 className={styles.services}>
                            {addon.quantity > 1
                              ? addon.service_name + ` (${addon.quantity})`
                              : addon.service_name}
                          </h4>
                        </div>
                        <div className={styles.adon_amount}>
                          &#8377;{addon.service_total}
                        </div>
                      </div>
                    ))}
                    {/* <div className="discountContainer">
                      <div className="saveoffer">Save 50%</div>
                      <div className="offerAmt">- &#8377; 1000 </div>
                    </div> */}
                    <div className={styles.finalAmt_container}>
                      <div className={styles.finalAMT}>
                        &#8377;{cartItem.service_total}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={`${styles.cart_main} ${styles.cart_final_amt}`}>
          <div
            className={`${styles.grand_total_container} ${styles.cart_main}`}
          >
            {/* <div className="address">
                Delivery Address : {addresses.address1 + addresses.address2}
              </div> */}
            <div className={styles.grd_total}>Total</div>
            <div className={styles.grd_amt}>&#8377;{cartTotal.toFixed(2)}</div>
          </div>
          <div className={`${styles.cart_main} ${styles.btn_main_proceed}`}>
            <button onClick={placeOrderHandler} className={styles.btn_checkout}>
              Place Order
            </button>
          </div>
        </div>
      </div>
      {msg && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setMsg("")}
          autoHideDuration={3000}
          message={msg}
        >
          <Alert severity="success">{msg}</Alert>
        </Snackbar>
      )}
    </>
  );
}

export default Checkout;
